import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { LanguageProvider } from './i18n/context';
import { AuthProvider } from './contexts/AuthContext';
import './styles/global.css';

// Privacy-friendly, cookieless audience measurement (Umami). Loads ONLY in
// PRODUCTION builds (never in dev/localhost, so local visits don't pollute the
// stats). The website id is a PUBLIC tracking id (it ships in the bundle either
// way), so it's safe in source; .env.* is gitignored here, hence the baked-in
// default. No cookies, no profiling → no consent banner required. Host defaults
// to Umami Cloud; override with VITE_UMAMI_SRC for a self-hosted instance.
{
  const umamiId = (import.meta.env.VITE_UMAMI_WEBSITE_ID as string | undefined)
    || (import.meta.env.PROD ? '30444457-0a6a-412e-a6ef-20731bbd3b99' : undefined);
  if (umamiId) {
    const s = document.createElement('script');
    s.defer = true;
    s.src = (import.meta.env.VITE_UMAMI_SRC as string) || 'https://cloud.umami.is/script.js';
    s.setAttribute('data-website-id', umamiId);
    document.head.appendChild(s);
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LanguageProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </LanguageProvider>
  </React.StrictMode>
);
